<template>
  <div class="edit-sharing-options">
    <label  v-if="comingFromMyShared">{{ $t('share_invite.email_sharing') }}</label>
    <a v-if="comingFromMyShared" href="#" class="pull-left shared-with my-shared-right" @click.prevent="$emit('edit-mode')">
      {{ $t('share_invite.share_with_more_people') }}
      <i class="fa fa-long-arrow-right"></i>
    </a>
    <a v-else href="#" class="pull-left shared-with" @click.prevent="$emit('edit-mode')">
      <i class="fa fa-long-arrow-left"></i>
      {{ $t('share_invite.share_with_other_people') }}
    </a>
    <div class="clearfix"></div>
    <div class="empty-list-wrapper" v-if="hasNoShareInvites()">
      <img src="../../assets/empty_states/shared_with_me.png"/>
      <p>{{ $t('share_invite.you_havent_shared_this_folder') }}</p>
    </div>
    <div class="shared-list-wrapper" v-else>
      <div v-for="share_invite in share_invites" class="shared-invite-line" :key='share_invite.id'>
        <img src="../../assets/no-picture.svg"/>
        <div class="shared-invite-body">
          <b>{{share_invite.contact.name}}</b>
          <br/>
          {{share_invite.contact.email}}
        </div>
        <div class="shared-invite-options">
          <select @change="changePermission(share_invite.id, $event)" name="share_invite[invite_type]" class="form-control" v-model="share_invite.invite_type">
            <option value="read">{{ $t('share_invite.can_read') }}</option>
            <option value="write">{{ $t('share_invite.can_edit') }}</option>
            <option value="all">{{ $t('share_invite.extended_write') }}</option>
            <option value="delete">{{ $t('share_invite.unshare') }}</option>
          </select>
        </div>
      </div>
    </div>
    <a href="" class="btn btn-neutral float-right" @click.prevent= "$emit('close-modal')">{{ $t('share_invite.close') }}</a>
  </div>
</template>

<script>
  export default {
    props: {
          folderId: Number,
          comingFromMyShared: {
            type: Boolean,
            required: false,
            default: false
          }
    },
    mounted: function () {
      this.store.getShareInvites(this.$props.folderId)
    },
    computed: {
      share_invites(){
        return this.state.shareInvitesStore ? this.state.shareInvitesStore.share_invites : []
      }
    },
    methods: {
      hasNoShareInvites () {
        return this.share_invites && this.share_invites.length === 0
      },
      changePermission (share_invite_id, event) {
        if ($(event.target).val() == 'delete') {
          this.axios.delete('/folders/' + this.$props.folderId + '/share_invites/' + share_invite_id)
            .then(res=>{
              this.$emit('success')
              this.store.getShareInvites(this.$props.folderId)
              this.$toastr.success(this.$t('share_invite.access_revoked'))
              this.store.sendMetrics({name: 'remove_folder_delete_permission', params: this.$route.params, path: this.$route.fullPath})
            })
        } else {
          let form_params = {share_invite:{invite_type: $(event.target).val()}}
          this.axios.patch('/folders/' + this.$props.folderId + '/share_invites/' + share_invite_id, form_params)
            .then(res=>{
              this.$emit('success')
              this.store.getShareInvites(this.$props.folderId)
              this.$toastr.success(this.$t('share_invite.perm_updated'))
              this.store.sendMetrics({name: 'update_folder_permission', params: this.$route.params, path: this.$route.fullPath})
            })
        }
      }
    }
  }
</script>

<style scoped>
  .shared-list-wrapper {
    width: 100%;
    max-height: 400px;
    overflow: auto;
    margin: 20px 0;
    border-top: 1px solid #e9ecef;
  }

  .shared-invite-line {
    width: 100%;
    overflow: auto;
    padding-top: 8px;
    padding-bottom: 7px;
    border-bottom: 1px solid #e9ecef;
  }

  .shared-invite-line img {
    float: left;
    margin-right: 10px;
    margin-left: 10px;
  }

  .shared-invite-line .shared-invite-body {
    width: calc(100% - 240px);
    float: left;
  }

  .shared-invite-line .shared-invite-options {
    width: 170px;
    float: right;
    padding-top: 3px;
  }

  .my-shared-right{
    float: right;
  }

  .shared-invite-line .shared-invite-options select {
    cursor: pointer;
  }
</style>
